/** Routes du module — propriétaire : Agent A2b — Administration commerciale (tableau de bord, inscriptions, clients, catalogue, tarifs). */
import type { RouteObject } from 'react-router';
import { BadgeEuro, ClipboardCheck, LayoutDashboard, Package, Tags, Users } from 'lucide-react';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { PageTableauDeBord } from './TableauDeBord';
import { PageDossierInscription, PageInscriptions } from './Inscriptions';
import { PageClients, PageFicheClient } from './Clients';
import { PageFicheProduit, PageNouveauProduit, PageProduits } from './Produits';
import { PageReferentiels } from './Referentiels';
import { PageTarifs } from './Tarifs';

export const routesAdminCommercial: RouteObject[] = [
  { index: true, element: <PageTableauDeBord /> },
  { path: 'inscriptions', element: <RequirePermission permission="client.inscription.valider"><PageInscriptions /></RequirePermission> },
  { path: 'inscriptions/:id', element: <RequirePermission permission="client.inscription.valider"><PageDossierInscription /></RequirePermission> },
  { path: 'clients', element: <RequirePermission permission="client.lire"><PageClients /></RequirePermission> },
  { path: 'clients/:id', element: <RequirePermission permission="client.lire"><PageFicheClient /></RequirePermission> },
  { path: 'produits', element: <RequirePermission permission="produit.lire"><PageProduits /></RequirePermission> },
  { path: 'produits/nouveau', element: <RequirePermission permission="produit.gerer"><PageNouveauProduit /></RequirePermission> },
  { path: 'produits/:id', element: <RequirePermission permission="produit.lire"><PageFicheProduit /></RequirePermission> },
  { path: 'referentiels', element: <RequirePermission permission="produit.lire"><PageReferentiels /></RequirePermission> },
  { path: 'tarifs', element: <RequirePermission permission="tarif.lire"><PageTarifs /></RequirePermission> },
];

export const navAdminCommercial: EntreeNav[] = [
  { libelle: 'Tableau de bord', vers: '/admin', exact: true, icone: LayoutDashboard, groupe: 'Pilotage' },
  { libelle: 'Inscriptions', vers: '/admin/inscriptions', permission: 'client.inscription.valider', icone: ClipboardCheck, groupe: 'Commercial' },
  { libelle: 'Clients', vers: '/admin/clients', permission: 'client.lire', icone: Users, groupe: 'Commercial' },
  { libelle: 'Produits', vers: '/admin/produits', permission: 'produit.lire', icone: Package, groupe: 'Catalogue' },
  { libelle: 'Catégories et marques', vers: '/admin/referentiels', permission: 'produit.lire', icone: Tags, groupe: 'Catalogue' },
  { libelle: 'Tarification', vers: '/admin/tarifs', permission: 'tarif.lire', icone: BadgeEuro, groupe: 'Catalogue' },
];
